module.exports = __webpack_public_path__ + "img/6_uk.fa251556.svg";